import useMathTitleSetup from '@/shared/hooks/useMathTitleSetup';
import * as Dialog from '@radix-ui/react-dialog';
import { FC, useEffect, useState } from 'react';

interface ListUnitProps extends API.CreatedBoxRange.MetaData {
    children: ListUnitProps[];
}

const ListUnit: FC<ListUnitProps> = (props) => {
    const { meta_id, meta_depth, meta_val, children } = props;
    const liCls = `depth${meta_depth === '4' ? '3' : meta_depth}-item`;
    const txtCls = liCls + '-txt';
    const contentCls = liCls + '-content';

    const valRef = useMathTitleSetup<HTMLDivElement>(meta_val);
    return (
        <li key={meta_id + liCls} className={liCls}>
            <div className={txtCls} ref={valRef}>
                {meta_val ? meta_val.replace(/학습맵|학습멥/g, '') : '-'}
            </div>
            {children && children.length > 0 && (
                <ul className={contentCls}>
                    {children.map((c) => (
                        <ListUnit key={c.meta_id} {...c} />
                    ))}
                </ul>
            )}
        </li>
    );
};

export const CreatedRangePopup = ({ rangeList }: { rangeList: API.CreatedBoxRange.MetaData[] }) => {
    const [list, setList] = useState<ListUnitProps[]>([]);

    useEffect(() => {
        if (rangeList?.length > 0) {
            const getProps = (data: API.CreatedBoxRange.MetaData): ListUnitProps => {
                const cList = rangeList.filter((l) => l.meta_parentId == data.meta_id);
                return {
                    ...data,
                    children: [...cList.map((c) => getProps(c))],
                };
            };
            const rootList = rangeList.filter((l) => l.meta_depth === '1');
            setList([...rootList.map((r) => getProps(r))]);
        }
    }, [rangeList]);

    return (
        <div className="pop_wrap pop_size9 range_pop_wrap">
            <div className="modal_header">
                <div className="title">출제범위</div>
            </div>
            <div className="pop_contents type-padding3">
                <div className="range-tree-wrap">
                    <ul className="range-tree-list">
                        {list.map((data) => (
                            <ListUnit key={data.meta_id} {...data} />
                        ))}
                    </ul>
                </div>
            </div>
            <Dialog.Close asChild>
                <button type="button" className="btn-x btn-x-white">
                    <span className="sr-only">팝업 닫기</span>
                </button>
            </Dialog.Close>
        </div>
    );
};
